jQuery(document).ready(function ($) {
    $('a.share-link-trigger').on('click touchstart', function (e) {

        if (e.handled === false) {
            return
        }

        e.preventDefault();

        //  Get the link attributes
        var $link = $(this);
        var href = $link.attr('href');
        var network = $link.attr('data-network');

        //  Different popup sizes
        var networks = {
            facebook: { width: 600, height: 450 },
            twitter: { width: 600, height: 450 },
            linkedin: { width: 600, height: 450 }
        };

        //  Set the opener options
        var options = 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,';

        //  Open the share window
        window.open(href, '', options + 'height=' + networks[network].height + ',width=' + networks[network].width);

    });
});